<div class="flex flex-col items-center">
  <div class="bg-lightGrayish mb-5 flex w-full max-w-7xl flex-col gap-4 p-5 lg:gap-5">
    <app-text-content-box [headline]="'Part-time training'" headerIcon="🗓️" class="lg:pb-2"></app-text-content-box>
    <div class="grid gap-4 md:grid-cols-2">
      <div data-cy="training-section">
        <label class="mb-2 block text-sm font-medium">Date of training</label>
        <input
          type="text"
          mwlFlatpickr
          placeholder="Date of training"
          class="placeholder-veryTransparentBlack flex w-full border border-gray-300 p-2.5 px-4 py-2 placeholder:font-semibold"
          [altInput]="true"
          [convertModelValue]="true"
          [options]="helperService.datePickerOptions"
          [(ngModel)]="training.trainingDate"
        />
      </div>
      <form [formGroup]="timeForm">
        <label class="mb-2 block text-sm font-medium">Hours worked</label>
        <input
          formControlName="timeInput"
          (input)="helperService.onTimeInput($event, timeForm)"
          type="text"
          placeholder="HH:MM"
          formControlName="timeInput"
          data-cy="training-time"
          class="placeholder-veryTransparentBlack flex w-full border border-gray-300 p-2.5 px-4 py-2 placeholder:font-semibold"
        />
      </form>
      <div>
        <label class="mb-2 block text-sm font-medium">Description</label>

        <input
          [(ngModel)]="training.description"
          class="placeholder-veryTransparentBlack block h-12 w-full border border-gray-300 p-2.5 placeholder:font-semibold"
          data-cy="description-input"
          type="text"
          placeholder="Description"
        />
      </div>
      <div>
        <label class="mb-2 block text-sm font-medium">Training method</label>

        <app-dropdown
          #dropdownComponent
          daty-cy="ct-training-method-dropdown"
          [elements]="getTrainingTypes()"
          placeholder="Select training method"
          [selectedElement]="training.method"
          (selectElement)="onSelectTrainingType($event)"
        ></app-dropdown>
      </div>
      <div>
        <label class="mb-2 block text-sm font-medium">Reason</label>

        <input
          [(ngModel)]="training.reason"
          class="placeholder-veryTransparentBlack block h-12 w-full border border-gray-300 p-2.5 placeholder:font-semibold"
          data-cy="reason-input"
          type="text"
          placeholder="Reason for training"
        />
      </div>
    </div>

    <div class="flex w-full justify-end">
      <button
        (click)="onAddWorktime()"
        class="bg-almostBlack flex h-12 w-28 items-center justify-center border-black"
        data-cy="ct-save-button"
      >
        <img class="h-[18px] cursor-pointer" src="assets/img/icons/save.png" alt="save" />
      </button>
    </div>
  </div>

  <div
    class="bg-lightGrayish mb-5 flex w-full max-w-7xl flex-col gap-4 p-5 lg:gap-5"
    data-cy="requested-trainings-overview"
  >
    <div class="flex items-center justify-between">
      <app-text-content-box headline="Requests overview" headerIcon="🗓️" class="lg:pb-2"></app-text-content-box>
      <div class="flex gap-4">
        <label class="text-sm font-medium text-black">Past requests</label>
        <input
          type="checkbox"
          class="before:bg-sunflowerGold flex h-5 w-9 min-w-[2rem] appearance-none items-center rounded-full bg-gray-300 shadow-inner transition-all duration-300 before:ml-0.5 before:inline-block before:h-4 before:w-4 before:rounded-full checked:bg-yellow-200 checked:before:translate-x-full focus:outline-none"
          data-cy="requested-trainings-toggle"
          (change)="toggleOpenTrainings()"
        />
      </div>
    </div>
    @if (!employeeTrainings || !employeeTrainings.length) {
      <div>
        @if (!showPastRequests) {
          <span>There are currently no past requests for trainings</span>
        }
        @if (showPastRequests) {
          <span>There are currently no requests for trainings</span>
        }
      </div>
    }

    @if (employeeTrainings && employeeTrainings.length) {
      <div class="max-h-80 overflow-y-auto">
        <div class="sticky top-0 flex w-full bg-black text-white">
          <div class="min-w-[10rem] flex-1 border-r bg-black p-2">Date</div>
          <div class="min-w-[10rem] flex-1 border-r bg-black p-2">Time worked</div>
          <div class="w-[45rem] min-w-[10rem] border-r bg-black p-2">Description</div>
          <div class="min-w-[10rem] border-r bg-black p-2">Method</div>
          <div class="w-[45rem] min-w-[10rem] border-r bg-black p-2">Reason</div>
          <div class="flex min-w-[10rem] flex-1 justify-center bg-black p-2">Status</div>
        </div>
        <div>
          @for (training of employeeTrainings; track training) {
            <div class="flex w-full">
              <div class="min-w-[10rem] flex-1 border-r border-b p-2">
                {{ getTrainingDate(training) | date: 'dd.MM.yyyy' }}
              </div>
              <div class="min-w-[10rem] flex-1 border-r border-b p-2">{{ getTrainingDuration(training.duration) }}</div>
              <div
                class="w-[45rem] min-w-[10rem] overflow-hidden border-r border-b p-2 text-ellipsis whitespace-nowrap"
                data-cy="training-description"
                [title]="training.description"
              >
                {{ training.description }}
              </div>
              <div
                class="min-w-[10rem] overflow-hidden border-r border-b p-2 text-ellipsis whitespace-nowrap"
                data-cy="requested-training-method"
              >
                {{ training.method }}
              </div>
              <div
                class="w-[45rem] min-w-[10rem] overflow-hidden border-r border-b p-2 text-ellipsis whitespace-nowrap"
                data-cy="training-reason"
                [title]="training.reason"
              >
                {{ training.reason }}
              </div>
              <div class="flex min-w-[10rem] flex-1 justify-center gap-8 border-r border-b p-2">
                @if (training.state === ETrainingState.REQUESTED) {
                  <span>Requested</span>
                }
                @if (training.state === ETrainingState.APPROVED) {
                  <span class="text-green-500" data-cy="requested-training-approved">Approved</span>
                }
                @if (training.state === ETrainingState.REJECTED) {
                  <span class="text-red-500">Rejected</span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
